import React, { useEffect, useState } from 'react'
import { Link, Outlet } from 'react-router-dom'
import Table from '../../Components/Script/Table'
import {
    getAllServiceGroups,
    createServiceGroup,
    updateServiceGroup
} from '../../Services/dynamicservice'

function ServiceGroupManage() {

    const [groups, setGroups] = useState([])
    const [groupName, setGroupName] = useState('')
    const [displayOrder, setDisplayOrder] = useState(0)
    const [isActive, setIsActive] = useState(true)

    const [selectedGroup, setSelectedGroup] = useState(null)

    useEffect(() => {
        fetchGroups()
    }, [])

    const fetchGroups = async () => {
        try {
            const data = await getAllServiceGroups()
            setGroups(data)
        } catch (error) {
            console.error("Error fetching groups:", error)
        }
    }

    /* CREATE */
    const handleSubmit = async (e) => {
        e.preventDefault()

        const payload = {
            name: groupName,
            displayOrder: displayOrder,
            isActive: isActive
        }

        try {
            await createServiceGroup(payload)
            fetchGroups()
            setGroupName('')
            setDisplayOrder(0)
            setIsActive(true)
        } catch (error) {
            alert("Failed to create group")
        }
    }

    /* OPEN UPDATE MODAL */
    const handleEdit = (group) => {
        setSelectedGroup(group)
        new window.bootstrap.Modal(
            document.getElementById('group-update-modal')
        ).show()
    }

    /* UPDATE */
    const handleUpdate = async (e) => {
        e.preventDefault()

        try {
            await updateServiceGroup(selectedGroup.id, selectedGroup)
            fetchGroups()

            const modalElement = document.getElementById('group-update-modal')
            const modalInstance = window.bootstrap.Modal.getInstance(modalElement)
            modalInstance?.hide()

        } catch (error) {
            alert("Update failed")
        }
    }

    return (
        <div>
            <Table />

            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">

                            {/* PAGE TITLE */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">Service Groups</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">Service Groups</h4>
                                    </div>
                                </div>
                            </div>

                            {/* CREATE FORM */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">

                                            <form onSubmit={handleSubmit}>
                                                <div className="row g-2">

                                                    <div className="mb-3 col-md-4">
                                                        <label className="form-label">Group Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={groupName}
                                                            onChange={(e) => setGroupName(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="mb-3 col-md-4">
                                                        <label className="form-label">Display Order</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={displayOrder}
                                                            onChange={(e) => setDisplayOrder(e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="mb-3 col-md-4">
                                                        <label className="form-label">Active</label>
                                                        <select
                                                            className="form-control"
                                                            value={isActive}
                                                            onChange={(e) => setIsActive(e.target.value === "true")}
                                                        >
                                                            <option value="true">Active</option>
                                                            <option value="false">Inactive</option>
                                                        </select>
                                                    </div>

                                                </div>

                                                <button type="submit" className="btn btn-primary">
                                                    Create Group
                                                </button>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* TABLE */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">

                                            <div className="table-responsive">
                                                <table className="table table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Order</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {groups.length > 0 ? (
                                                            groups.map((group) => (
                                                                <tr key={group.id}>
                                                                    <td>{group.name}</td>
                                                                    <td>{group.displayOrder}</td>
                                                                    <td>
                                                                        {group.isActive ? "Active" : "Inactive"}
                                                                    </td>
                                                                    <td>
                                                                        <i
                                                                            className="mdi mdi-pencil action-icon"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => handleEdit(group)}
                                                                        ></i>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="4" className="text-center">
                                                                    No Data Found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* UPDATE MODAL */}
                            {selectedGroup && (
                                <div className="modal fade" id="group-update-modal" tabIndex="-1">
                                    <div className="modal-dialog">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">Update Group</h5>
                                            </div>

                                            <div className="modal-body">
                                                <form onSubmit={handleUpdate}>

                                                    {/* NAME */}
                                                    <div className="mb-3">
                                                        <label className="form-label">Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={selectedGroup.name}
                                                            onChange={(e) =>
                                                                setSelectedGroup({
                                                                    ...selectedGroup,
                                                                    name: e.target.value
                                                                })
                                                            }
                                                        />
                                                    </div>

                                                    {/* DISPLAY ORDER */}
                                                    <div className="mb-3">
                                                        <label className="form-label">Display Order</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={selectedGroup.displayOrder}
                                                            onChange={(e) =>
                                                                setSelectedGroup({
                                                                    ...selectedGroup,
                                                                    displayOrder: parseInt(e.target.value)
                                                                })
                                                            }
                                                        />
                                                    </div>

                                                    {/* ACTIVE / INACTIVE */}
                                                    <div className="mb-3">
                                                        <label className="form-label">Status</label>
                                                        <select
                                                            className="form-control"
                                                            value={selectedGroup.isActive}
                                                            onChange={(e) =>
                                                                setSelectedGroup({
                                                                    ...selectedGroup,
                                                                    isActive: e.target.value === "true"
                                                                })
                                                            }
                                                        >
                                                            <option value="true">Active</option>
                                                            <option value="false">Inactive</option>
                                                        </select>
                                                    </div>

                                                    <button type="submit" className="btn btn-primary">
                                                        Update
                                                    </button>

                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                        </div>
                    </div>
                </div>
            </div>

            <Outlet />
        </div>
    )
}

export default ServiceGroupManage
